import { fade } from '@material-ui/core/styles';

const drawerWidth = 460;

export default (theme) => ({
  room: {
    'display': 'flex',
    'position': 'fixed',
    'left': 0,
    'right': 0,
    'bottom': 0,
    'top': 0,
    'background': '#474747',
    'zIndex': 1,
    'color': 'white',
    '& .participants': {
      'width': '100%',
      'height': 'calc(100vh - 88px)',
      'display': 'flex',
      'flexWrap': 'wrap',
      'alignItems': 'center',
      'alignContent': 'center',
      'justifyContent': 'center',
      'marginTop': 'auto',
      'marginBottom': 'auto',
      'transition': 'all .2s ease',
      '&.small': {
        'width': 220,
        'flexWrap': 'nowrap',
        'overflowY': 'auto',
        'position': 'absolute',
        'right': 0,
        'top': 0,
        'flexDirection': 'column',
        'justifyContent': 'flex-start',
        '& .participant': {
          'flex': 0,
          'flexBasis': 'unset !important',
          'max-height': 140,
          'width': '90% !important',
          '& .username': {
            fontSize: 13,
          },
        },
      },
    },
    '& .participant': {
      'margin': 5,
      'borderRadius': 4,
      'backgroundColor': 'black',
      'position': 'relative',
      '& video': {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
      },
      '& .username': {
        color: 'white',
        backgroundColor: 'rgba(23,24,25,.8)',
        padding: '4px 8px',
      },
      '& .video-icons': {
        display: 'flex',
        justifyContent: 'space-between',
        height: 25,
        padding: 4,
      },
      '& .video-details': {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        position: 'absolute',
        bottom: 0,
        zIndex: 1,
      },
      '& .mic-off': {
        color: theme.palette.secondary.main,
      },
      '& .mic-on': {
        color: 'white',
      },
    },
    '& .screen-container': {
      'flex': 1,
      'width': 'calc(100vw - 220px)',
      'height': 'calc(100vh - 88px)',
      'padding': theme.spacing(1),
      '& .screen-share-text': {
        backgroundColor: theme.palette.primary['50'],
        color: theme.palette.text.primary,
        padding: theme.spacing(1),
      },
      '& .presenting-text': {
        color: theme.palette.text.primary,
        padding: theme.spacing(4),
        paddingTop: theme.spacing(3),
        fontSize: 32,
        color: theme.palette.primary.contrastText
      },
    },
    '& .screen': {
      width: '100%',
      height: '100%',
    },
  },
  activeVideo: {},
  videoSmall: {
    width: 200,
    height: 200,
    border: '1px solid red',
  },
  footer: {
    'position': 'fixed',
    'display': 'flex',
    'alignItems': 'center',
    'padding': theme.spacing(1.5),
    'bottom': 0,
    'margin': 'auto',
    'left': 0,
    'right': 0,
    'textAlign': 'center',
    '& button': {
      margin: '0 8px',
    },
    '& > div': {
      flex: 1,
    },
  },
  fab: {
    backgroundColor: theme.palette.background.paper,
    border: '1px solid',
    borderColor: fade(theme.palette.text.secondary, 0.2),
    boxShadow: 'none',
    color: theme.palette.text.dark,
  },
  duration: {
    backgroundColor: 'rgba(0,0,0,.5)',
    color: 'white',
    padding: '0 6px',
    borderRadius: 4,
  },
  sharingBanner: {
    position: 'fixed',
    zIndex: 1,
    top: 0,
    left: 0,
    right: 0,
    padding: 20,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.success.main,
    color: 'white',
    boxShadow: '0 2px 3px rgba(0,0,0,.2)',
  },
  header: {
    position: 'absolute',
    top: 10,
    left: 10,
    zIndex: 1,
    display: 'flex',
    alignItems: 'center',
  },
  recording: {
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.secondary.main,
    fontSize: 12,
    fontWeight: 600,
    marginLeft: 4,
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  content: {
    flexGrow: 1,
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginRight: -drawerWidth,
  },
  contentShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginRight: 0,
  },
});
